package com.example.event_management_system.data.repository

import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.FirebaseUser
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class AuthRepository(
    private val auth: FirebaseAuth
) : IAuthRepository {
    val currentUser: FirebaseUser?
        get() = auth.currentUser

    override val isLoggedIn: Boolean
        get() = auth.currentUser != null

    val authStateFlow: Flow<FirebaseUser?> = auth.authStateChanged

    override suspend fun signIn(email: String, password: String): Result<String> {
        return try {
            val result = auth.signInWithEmailAndPassword(email, password)
            result.user?.uid?.let {
                Result.success(it)
            } ?: Result.failure(Exception("Sign in failed: No user returned"))
        } catch (e: Throwable) {
            Result.failure(Exception(e.message ?: "Sign in failed", e))
        }
    }

    override suspend fun signOut() {
        auth.signOut()
    }

    override suspend fun resetPassword(email: String): Result<Unit> {
        return try {
            auth.sendPasswordResetEmail(email)
            Result.success(Unit)
        } catch (e: Throwable) {
            Result.failure(Exception(e.message ?: "Password reset failed", e))
        }
    }

    override fun getCurrentUserId(): String? {
        return auth.currentUser?.uid
    }
}
